<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <Modal
    :closable="false"
    :width="850"
    @on-hidden="onHidden"
    class="modal-setting"
    class-name="vertical-center-modal"
    footer-hide
    :title="modalType==='create'?'新增案例':'编辑案例'"
    v-model="modalShowHide"
  >
    <div style="background-color: #F4F8FF;">
      <div class="w-full  noscroll o-y-auto bg-white">
        <div class="m-auto bg-white" style="width: 850px;">
          <div class="p-h-40 p-b-15">
            <Row :gutter="15">
              <Col span="10">
                <class-vertical-choose-widget
                  :objData="objData"
                  :srcType="8" direction="horizontal"
                  leftLabelText="案例分类"
                  ref="classChoosWidget"
                  rightLabelText="案例分组">

                </class-vertical-choose-widget>
              </Col>
              <Col span="7">
                <div class="fs-14 bold">关联商品：</div>
                <Input :value="getGoodsName" @on-clear="onInputClearClick" class="p-t-10 "
                       clearable placeholder="关联商品"
                       readonly>
                  <template #append>
                    <Button @click="onProductChooseClick" icon="md-add"
                            style="width: 50px"></Button>
                  </template>
                </Input>
              </Col>
              <Col span="7">
                <div class="fs-14 bold">发布人：</div>
                <Input :value="getPersonName" @on-clear="onInputPersonClearClick" class="p-t-10 "
                       clearable placeholder="发布人"
                       readonly>
                  <template #append>
                    <Button @click="onCustomerChooseClick" icon="md-add"
                            style="width: 50px"></Button>
                  </template>
                </Input>
              </Col>
            </Row>
          </div>
          <Input class=" p-h-40 " maxlength="32" placeholder="案例标题" v-model="title"></Input>
          <Input :rows="4" class=" p-t-15 fs-14  p-h-40" placeholder="案例内容" type="textarea"
                 v-model="content"></Input>

          <div class="fs-14 bold p-t-15 p-h-40">案例详情：</div>
          <!--              class="noscroll  o-y-auto"-->
          <div
            style="height: 360px; margin-left: 40px;padding-bottom:20px;display: flex;flex-wrap: wrap;flex-direction: column">
            <ul>
              <li class=" clear" style="float:left;margin-right: 15px;margin-top: 20px;"
                  v-if="!(imageList && imageList.length)">
                <video-edit-test2
                  :always-show-upload="true"
                  :coverEnable="coverEnable"
                  :hasPathProName=false
                  :height="145 + 'px'"
                  :videoinfo="videoinfos" :vidupload="false" :width="182 + 'px'"
                  @configvideoclick="onvideoClick"
                  @onConfigCancelClick="showVideoEdit=false"
                  @uploadVideoSuccess="uploadVideoSuccess"
                  videoInfix="bbs/content/"/>
              </li>

              <li class="clear" style="float:left;margin-right: 15px;margin-top: 20px;"
                  v-if="!videoinfos.videoUrl">
                <up-load-image :hasPathProName=false @uploadSuccess="uploadDescImageSuccess"
                               accept="image/*"
                               multiple
                               picurl="bbs/effect/"
                               style="width:182px;height: 145px;">
                  <template v-slot:tip>
                    <div style="width: 182px;">
                      <div class="flex-column a-center j-center  m-b-10"
                           style="width: 182px;height: 145px;background-color: #F6F9FF;cursor: pointer">
                        <img alt="" src="../../../assets/common/ic_upload_picture@2x.png"
                             style="width: 64px;height: 64px">
                        <span class="m-t-5  color-66">上传图片</span>
                      </div>
                    </div>
                  </template>
                </up-load-image>
              </li>

              <li class=" clear" style="float:left;margin-right: 15px;margin-top: 20px;"
                  v-if="videoinfos.localUrl||videoinfos.videoUrl || videoinfos.videoAliVid">

                <div :style="{width:width,height:height}" class="video-style relative"
                     style="width: 182px;height:145px;">
                  <div :style="{width:width,height:height}" class="relative"
                       style="width: 182px;height:145px; "
                       v-show="getvideourl">
                    <video :src="getvideourl" :style="{height:height,width: width}" alt=""
                           id="video-sid"
                           style="object-fit: fill"/>
                    <img :src="videoinfos.imgUrl" :style="{width:width,height:height}" alt=""
                         class="absolute top-0 left-0"
                         style="width: 182px;height:145px; "
                         v-if="getvideourl && videoinfos.imgUrl">
                    <img class="play-img-style"
                         src="../../../assets/common/ic_shipinbiaozhi_white@2x.png"
                         v-if="getvideourl && videoinfos.imgUrl">
                  </div>
                  <video-player :poster="videoinfos.imgUrl" :style="{width:width,height:height}"
                                :vid="videoinfos.videoAliVid"
                                aspectRatio="16:9"
                                ref="players"
                                style="width: 182px;height:145px; "
                                v-show="videoinfos.videoAliVid && !videoinfos.localUrl && !videoinfos.videoUrl"/>
                  <div :style="{width:width,height:height}" @click.stop="onButtomClick"
                       class="absolute top-0 "
                       style="width: 182px;height:145px; background-color: #00000040;cursor: pointer;"
                       v-if="videoinfos.localUrl ||videoinfos.videoUrl || videoinfos.videoAliVid "></div>
                  <p @click="onDeleteVideo()" class="delete-style" style="top: -7px;right: -7px;"
                     v-if="videoinfos.localUrl||videoinfos.videoUrl || videoinfos.videoAliVid"><span
                    class="delete-inner"></span></p></div>
              </li>

              <draggable :move="onMove"
                         :options="dragOptions1"
                         @end="isDragging=false"
                         @start="isDragging=true"
                         element="ul"
                         v-model="imageList">
                <li :key="index" class="clear"
                    style="float: left;margin-right: 15px;margin-top: 20px"
                    v-for="(item,index) in imageList">
                  <div class="border  relative hoverstyle" style="width:182px;height: 145px;">
                    <div class="w-full o-hidden" style="height: 145px;">
                      <img :src="item.url" alt="" class="w-full v-a-center"
                           style="object-fit: fill;width: 100%;height: 145px">
                    </div>
                    <div @click="onItemDel(imageList,index)" class="showdel"
                         style="position: absolute;top: -10px;right: -10px">
                      <i class="icon-delete_small fs-20"
                         style="color: #F44336;cursor: pointer"/>
                    </div>
                  </div>
                </li>
              </draggable>
            </ul>
          </div>
        </div>
      </div>

      <!--        <div class="m-auto bg-white flex a-center j-end"-->
      <!--             style="width: 820px;position: sticky;bottom: 0;left: 0;height: 64px;box-shadow: 0 0 8px 0 rgba(1, 0, 52, 0.12);">-->
      <!--          <Button @click="goBack" style="width: 76px">取消</Button>-->
      <!--          <Button @click="onSaveClick" class="m-l-20" style="margin-right: 38px;width: 76px"-->
      <!--                  type="primary">保存-->
      <!--          </Button>-->
      <!--        </div>-->
      <div class="w-full flex j-center p-v-10 bg-white" slot="footer">
        <Button @click="cancel" style="width: 100px">取消</Button>
        <Button @click="onSaveClick" style="margin-left: 50px;width: 100px" type="primary">确定
        </Button>
      </div>

    </div>
    <Modal
      @on-visible-change="onVideoPrewModalClose"
      class-name="vertical-center-modal"
      footer-hide
      v-model="showVideoPrew"
      width="650">
      <video-prew :videoinfo="videoprewinfo" ref="prewplayer"/>
    </Modal>
    <Modal :closable="false"
           :mask-closable="false"
           @on-visible-change="onModalProductChooseClose"
           class="prewmodal"
           class-name="vertical-center-modal"
           footer-hide
           v-model="showprochoose"
           width="1200">
      <product-choose-widget :multiSelect="false" :open="showprochoose"
                             :selectedRows="selectedRows"
                             @cancel="showprochoose=false"
                             @ok="onProductSave"></product-choose-widget>
    </Modal>

    <Modal :closable="false"
           :mask-closable="false"
           @on-visible-change="onModalProductChooseClose"
           class="prewmodal"
           class-name="vertical-center-modal"
           footer-hide
           v-model="showServicechoose"
           width="900">
      <service-choose-widget :open="showServicechoose" @cancel="showServicechoose=false"
                             @ok="onServicesPersonSave"></service-choose-widget>
    </Modal>
  </Modal>
</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import UpLoadImage from '@/components/common/UpLoadImage'
import draggable from 'vuedraggable'
import UpLoadVideo from '@/components/common/UpLoadVideo'
import VideoPlayer from '@/components/common/VideoPlayer'
import videoEditTest2 from '@/components/common/VideoEditTest2'
import VideoPrew from '@/components/common/VideoPrew'
import ClassVerticalChooseWidget from '../../../components/common/ClassVerticalChooseWidget'
import {mapActions, mapMutations} from 'vuex'
import ProductChooseWidget from '../../../components/product/ProductChooseWidget'
import ServiceChooseWidget from './components/ServiceChooseWidget'

export default {
  name: 'ExampleModal',
  components: {
    ServiceChooseWidget,
    ProductChooseWidget,
    ClassVerticalChooseWidget,
    BasePageComponent,
    UpLoadImage,
    UpLoadVideo,
    videoEditTest2,
    VideoPlayer,
    VideoPrew,
    draggable,
  },
  props: {
    // 点击确认
    onOk: Function,
    // 点击取消
    onCancel: Function,
  },
  data () {
    return {
      modalType: 'create', //弹框类型: create:新建案例弹框,edit:编辑案例弹框
      //编辑模式 案例id
      caseId: 0,
      //编辑模式  row数据, 编辑模式 保存时,修改
      editRowData: {},

      //显示隐藏
      modalShowHide: false,

      coverEnable: true,
      width: '182px',
      height: '145px',
      objData: {
        classId: 0,
        groupId: 0,
        init: false
      },
      title: '',
      content: '',

      showprochoose: false,
      // goodsId: 0,               //关联商品
      // goodsName: '',              //关联商品名称

      isDragging: false,
      imageList: [],            // 图片列表
      process: '',
      videoinfos: {  //视频信息
        id: 0,            //这条视频在后台库的Id
        videoAliVid: '',  //阿里云路径
        localUrl: '',     //本地路径
        videoUrl: '',     //Oss视频路径
        videoTitle: '',   //视频标题
        imgUrl: '',       //视频封面
        videoTime: '',    //视频时长
        videoSize: '',    //视频大小
        videoDesc: ''     //视频描述
      },
      videoprewinfo: {       //预览参数
        videoAliVid: '',
        videoUrl: '',
        coverUrl: '',
        videoTitle: ''
      },
      showVideoPrew: false,
      selectProductObjs: [],
      selectedRows: [],
      showServicechoose: false,         //选择客服人员
      publishObj: {
        id: 0,
        name: '',
        logo: '',
      }
    }
  },
  computed: {
    dragOptions1 () {    //拖动参数
      return {
        animation: 0,
        group: {
          name: 'description',
          // pull: 'clone',
          // put: false
        },
        scroll: true,
        ghostClass: 'ghost',
        scrollSensitivity: 30,
        forceFallback: false,
        disabled: false
      }
    },
    getvideourl () {
      if (this.videoinfos.localUrl) {
        console.log(this.videoinfos.localUrl)
        return this.videoinfos.localUrl
      }
      if (this.videoinfos.videoUrl) {
        console.log(this.videoinfos.videoUrl)
        return this.videoinfos.videoUrl
      }
      return ''
    },
    getGoodsName () {
      let text = ''
      if (this.selectProductObjs && this.selectProductObjs.length) {
        text = this.selectProductObjs.map(res => {
          return res.name
        }).join(',')
      }
      return text
    },
    getPersonName () {
      let text = ''
      if (this.publishObj && this.publishObj.id && this.publishObj.name) {
        text = this.publishObj.name
      }
      return text
    }
  },

  mounted () {
    this.init()
  },
  activated () {
    if (this.$route.query.id) {
      this.selectProductObjs = [{
        id: parseInt(this.$route.query.id || 0),
        name: this.$route.query.name || ''
      }]
    }
  },
  methods: {
    init () {

    },
    back () {
      window.history.back()
    },
    onMove ({relatedContext, draggedContext}) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      )
    },
    /**
     * 图片删除处理
     * @param arrayList
     * @param index
     */
    onItemDel (arrayList, index) {
      arrayList.splice(index, 1)
    },
    /**
     *上传图片
     * @param data
     */
    uploadDescImageSuccess (data) {
      if (data && data.length) {
        let list = data.map(res => {
          return {
            url: res.url,
            width: res.width,
            height: res.height,
            title: res.oldname || ''
          }
        })
        this.imageList = this.imageList.concat(list)
      }
    },
    onVideoUpload (data) {
      this.process = Number.parseInt(data * 100) + '%'
    },
    onDeleteVideo () {
      this.videoinfos = {
        videoAliVid: '',
        videoUrl: '',
        localUrl: '',
        videoTitle: '',
        imgUrl: '',
        videoTime: '',
        videoSize: '',
        videoDesc: '',
      }
    },
    onButtomClick () {
      let item = this.videoinfos
      if (item.videoUrl || item.videoAliVid) {
        this.videoprewinfo = {
          videoUrl: item.videoUrl || '',
          videoAliVid: item.videoAliVid || '',
          coverUrl: item.imgUrl,
          videoTitle: item.videoTitle
        }
        this.showVideoPrew = true
      }
    },
    getTitleByFiles (localfile) {
      let filename = ''
      if (localfile && localfile.name) {
        filename = localfile.name.split('.')[0]
      }
      return filename
    },
    uploadImageStart () {
    },
    uploadVideoSuccess (data) {
      this.videoinfos.videoAliVid = data[0].videoId
      this.videoinfos.localUrl = data[0].localUrl
      this.videoinfos.videoUrl = data[0].videoUrl
      this.videoinfos.videoSize = data[0].localfile.size
      if (!this.videoinfos.videoTitle) {
        this.videoinfos.videoTitle = this.getTitleByFiles(data[0].localfile)
      }
      this.process = ''
    },
    onVideoPrewModalClose (status) {
      if (!status) {
        this.videoprewinfo = {
          videoUrl: '',
          videoAliVid: '',
          coverUrl: '',
          videoTitle: ''
        }
      }
    },
    //保存
    onSaveClick () {
      // if (!this.title) {
      //   return this.$Message.info('请输入案例标题')
      // }
      let imageList = this.imageList.map((child, index) => {
        return {
          id: 0,
          type: 1,
          imgUrl: child.url || '',
          videoUrl: '',
          width: child.width || 0,
          height: child.height || 0,
          length: 0,
          title: child.title || '',
          desc: '',
          extension: '',
          jumpLink: '',
          sort: index + 1
        }
      })

      let videoList = []
      if (this.videoinfos.videoUrl) {
        let video = document.getElementById('video-sid')
        let duration = 0
        let width = 0
        let height = 0
        if (video && (this.videoinfos.localUrl || this.videoinfos.videoUrl)) {
          duration = video.duration
          width = video.videoWidth
          height = video.videoHeight
        }
        videoList = [{
          id: this.videoinfos.id || 0,
          // id: 0,
          type: 2,
          imgUrl: '',
          videoUrl: this.videoinfos.videoUrl || '',
          width: width || 0,
          height: height || 0,
          length: duration || 0,
          title: this.videoinfos.videoTitle || '',
          desc: this.videoinfos.videoDesc || '',
          extension: '',
          jumpLink: '',
          sort: 1
        }]
      }

      let imglen = imageList.length || 0
      let videolen = videoList.length || 0
      if (!(imglen || videolen || this.content)) {
        return this.$Message.info('请完善案例内容')
      }

      let showRoleId = 0
      if (this.publishObj && this.publishObj.id) {
        showRoleId = this.publishObj.id
      }
      let params = {
        categoryId: this.objData.classId,
        groupId: this.objData.groupId,
        type: 2,
        title: this.title,
        content: this.content,
        imgList: imageList || [],
        videoList: videoList || [],
        showRoleId: showRoleId
      }

      if (this.selectProductObjs && this.selectProductObjs.length) {
        params.goodsList = this.selectProductObjs.map(res => {
          return {
            id: res.id
          }
        })
      } else {
        params.goodsList = []
      }

      let type = this.modalType
      if (type === 'create') {       //创建案例
        this.addbbs(params).then(res => {
          if (res.code === 0) {
            // this.goBack()
            this.hide()
            if (this.onOk) {
              this.onOk()
            }
          } else {
            this.$Message.info(res.msg)
          }
        })
      } else if (type === 'edit') { //编辑案例
        let postId = this.caseId
        this.editbbs({
          postId,
          params
        }).then(async res => {
          if (res.code === 0) {
            // 修改row数据
            let className = ''
            let classData = this.$refs.classChoosWidget.classifyList.find(item => item.id === this.objData.classId)
            if (classData) className = classData.name || ''
            let groupName = ''
            let groupData = this.$refs.classChoosWidget.groupDatas.find(item => item.id === this.objData.groupId)
            if (groupData) groupName = groupData.name
            let imageCount = this.imageList ? this.imageList.length : 0

            let result = await this.getbbsDetail({
              id: postId
            })

            // 设置值
            let row = this.editRowData
            if (result.code === 0) {
              row.user = result.data.user
            }
            row.videoList = videoList
            row.imgList = imageList
            row.goodsList = this.selectProductObjs || []
            row.categoryName = className
            row.groupName = groupName
            row.imageCount = imageCount
            row.title = this.title
            row.content = this.content
            // if (row.user) {
            //   row.user.name = this.publishObj.name || ''
            //   row.user.icon = this.publishObj.logo || ''
            // } else {
            //   row.user = {
            //     name: this.publishObj.name || '',
            //     icon: this.publishObj.logo || ''
            //   }
            // }

            this.hide()
            if (this.onOk) {
              this.onOk()
            }
          } else {
            this.$Message.info(res.msg)
          }
        })
      }
    },
    onvideoClick () {

    },
    onModalProductChooseClose (status) {
      if (!status) {

      }
    },
    onProductChooseClick () {
      this.selectedRows = JSON.parse(JSON.stringify(this.selectProductObjs))
      this.showprochoose = true
    },
    onProductSave (list) {
      if (list && list.length) {
        this.selectProductObjs = list
      } else {
        this.selectProductObjs = []
      }
      this.showprochoose = false
    },
    onInputClearClick () {
      this.selectProductObjs = []
    },
    onInputPersonClearClick () {
      this.publishObj = {
        id: 0,
        name: '',
        logo: '',
      }
    },
    onCustomerChooseClick () {
      this.showServicechoose = true
    },
    onServicesPersonSave (data) {
      if (data && data.length) {
        let info = data[0]
        this.publishObj = {
          id: info.id,
          name: info.name || '',
          logo: info.logo,
        }
      }
      this.showServicechoose = false
    },
    /**
     * 显示弹框 创建案例
     */
    showCreate (selectedClassId = 0, selectedGroupId = 0, selectedProductId = 0, selectedProductName = '') {
      this.modalType = 'create'

      this.objData = {
        classId: selectedClassId,
        groupId: selectedGroupId,
        init: true
      }
      if (selectedProductId) {
        this.selectProductObjs = [{
          id: selectedProductId || 0,
          name: selectedProductName || ''
        }]
      }
      this.modalShowHide = true
    },

    /**
     * 显示弹框 编辑案例
     */
    showEdit (row) {
      this.modalType = 'edit'
      this.caseId = row.id
      this.editRowData = row
      this.getDetails()
      this.modalShowHide = true
    },

    /**
     * 隐藏弹框
     */
    hide () {
      this.modalShowHide = false
    },

    /**
     * 隐藏时,清空数据
     */
    onHidden () {
      //还原数据
      this.objData = {
        classId: 0,
        groupId: 0,
        init: false
      }
      this.title = ''
      this.content = ''

      this.showprochoose = false

      this.imageList = []
      this.videoinfos = {  //视频信息
        id: 0,            //这条视频在后台库的Id
        videoAliVid: '',  //阿里云路径
        localUrl: '',     //本地路径
        videoUrl: '',     //Oss视频路径
        videoTitle: '',   //视频标题
        imgUrl: '',       //视频封面
        videoTime: '',    //视频时长
        videoSize: '',    //视频大小
        videoDesc: ''     //视频描述
      }
      this.videoprewinfo = {       //预览参数
        videoAliVid: '',
        videoUrl: '',
        coverUrl: '',
        videoTitle: ''
      }
      this.selectProductObjs = []
      this.selectedRows = []
      this.publishObj = {
        id: 0,
        name: '',
        logo: '',
      }
    },

    /**
     * 获取案例详情
     */
    getDetails () {
      let id = this.caseId
      this.getbbsDetail({
        id
      }).then(res => {
        if (res.code === 0) {
          if (res.data.imgList && res.data.imgList.length) {
            this.imageList = res.data.imgList.map(child => {
              return {
                id: child.id || 0,
                url: child.imgUrl,
                width: child.width,
                height: child.height,
                title: child.title || ''
              }
            })
          }
          this.content = res.data.content || ''
          this.title = res.data.title || ''
          let classId = res.data.category ? res.data.category.id || 0 : 0
          let groupId = res.data.group ? res.data.group.id || 0 : 0
          this.publishObj = {
            id: res.data.showRoleId || 0,
            name: res.data.user ? res.data.user.name || '' : '',
            logo: res.data.user ? res.data.user.icon || '' : ''
          }
          this.objData = {
            classId: classId || 0,
            groupId: groupId || 0,
            init: true
          }

          if (res.data.videoList && res.data.videoList.length) {
            let videoInfo = res.data.videoList[0]
            this.videoinfos = {
              id: videoInfo.id || 0,            //这条视频在后台库的Id
              videoAliVid: '',  //阿里云路径
              localUrl: '',     //本地路径
              videoUrl: videoInfo.videoUrl || '',     //Oss视频路径
              videoTitle: videoInfo.title || '',   //视频标题
              imgUrl: videoInfo.imgUrl || '',       //视频封面
              videoTime: '',    //视频时长
              videoSize: '',    //视频大小
              videoDesc: ''     //视频描述
            }
          }

          if (res.data.goodsList && res.data.goodsList.length) {
            this.selectProductObjs = res.data.goodsList.map(proInfo => {
              return {
                id: proInfo.id || 0,
                name: proInfo.name || ''
              }
            })
          }
        }
      })
    },


    /**
     * 点击确认
     */
    ok () {
      this.onSaveClick()
    },

    /**
     * 点击取消
     */
    cancel () {
      this.hide()
      if (this.onCancel)
        this.onCancel()
    },
    ...mapMutations([
      'closeTag'
    ]),
    ...mapActions([
      'addbbs',
      'editbbs',
      'getbbsDetail'
    ])
  }
}
</script>

<style lang="scss" scoped>
.hoverstyle {
  &:hover {
    .showdel {
      display: block;
    }
  }

  .showdel {
    display: none;
  }
}

.modal-setting ::v-deep {

  .ivu-modal-header {
    background-color: #EEEEEE;
    margin-bottom: 15px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    max-height: 45px;
  }

  .ivu-modal-header-inner {
    display: flex;
    justify-content: center;
    font-weight: bold;
  }

  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  //标题下横线
  .ivu-modal-header {
    border-bottom: none;
  }

  //确认取消按钮上面红线
  .ivu-modal-footer {
    border-top: none;
  }
}

</style>
<style scoped>
.prewmodal >>> .ivu-modal-body {
  padding: 0;
}
</style>
